module.exports = __webpack_public_path__ + "img/allinone.0ab9cd98.svg";